import { useHistory } from 'react-router-dom';
import clsx from 'clsx';
import { translate } from 'src/locales/i18next/config';
import Translations from 'src/locales/i18next/translations/translation';
import { ITabItem } from './shared/types';

interface ITabsProps<TTabKey extends string> {
  tabs: ITabItem<TTabKey>[];
  activeTab?: TTabKey;
  onChange: (tab: TTabKey) => void;
  disabled?: boolean;
}

export default function Tabs<TTabKey extends string>(props: ITabsProps<TTabKey>) {
  const { tabs, activeTab, onChange, disabled = false } = props;

  const t = translate(Translations);

  const history = useHistory();

  if (!tabs.length) return null;
  return (
    <>
      <div className="card-header card-header-stretch overflow-auto">
        <ul className="nav nav-stretch nav-line-tabs fw-bold border-transparent flex-nowrap" role="tablist">
          {tabs.map((tab) => {
            const isCurrentPath = history.location.pathname === tab?.slug;
            const isActive = isCurrentPath || activeTab === tab.key;

            return (
              <li className="nav-item" key={tab.key}>
                <button
                  type="button"
                  className={clsx(`nav-link`, {
                    active: isActive,
                  })}
                  onClick={(e) => {
                    e.preventDefault();

                    onChange(tab.key);

                    if (tab?.slug) {
                      history.push(tab?.slug);
                      return;
                    }
                  }}
                  disabled={disabled}
                >
                  {t(tab.i18nKey, undefined, tab?.i18nFallbackText || undefined)}
                </button>
              </li>
            );
          })}
        </ul>
      </div>
    </>
  );
}
